import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';

const ResetPassword = () => {
    const { resetToken } = useParams(); // Get reset token from URL
    const navigate = useNavigate();
    const [formData, setFormData] = useState({ password: '', confirmPassword: '' });
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrors({});

        // Basic validation for password
        if (!formData.password) {
            setErrors({ password: 'Password is required' });
            return;
        }
        if (formData.password !== formData.confirmPassword) {
            setErrors({ confirmPassword: 'Passwords do not match' });
            return;
        }

        setLoading(true);

        try {
            const response = await axios.post(
                `https://rvapi.emedha.in/auth/api/reset-password/${resetToken}`,
                { password: formData.password }
            );

            setMessage(response.data.message);
            navigate('/'); // Redirect to login page after successful reset
        } catch (error) {
            setMessage(error.response ? error.response.data.error : 'Something went wrong');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            className="d-flex align-items-center justify-content-center min-vh-100"
            style={{
                background: 'linear-gradient(to right, #6a11cb 0%, #2575fc 100%)',
                padding: '20px',
            }}
        >
            <div
                className="p-4"
                style={{
                    backgroundColor: 'white',
                    borderRadius: '8px',
                    boxShadow: '0 10px 20px rgba(0, 0, 0, 0.1)',
                    width: '100%',
                    maxWidth: '400px',
                }}
            >
                <div className="text-center">
                    <h2 className="mb-4" style={{ fontFamily: 'Arial, sans-serif', color: '#333' }}>
                        Reset Password
                    </h2>
                </div>

                <form onSubmit={handleSubmit}>
                    {/* Password Input */}
                    <div className="mb-3">
                        <label className="form-label" style={{ fontWeight: '500' }}>
                            New Password
                        </label>
                        <input
                            type="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            className="form-control"
                            placeholder="Enter new password"
                        />
                        {errors.password && <div className="text-danger">{errors.password}</div>}
                    </div>

                    {/* Confirm Password Input */}
                    <div className="mb-3">
                        <label className="form-label" style={{ fontWeight: '500' }}>
                            Confirm Password
                        </label>
                        <input
                            type="password"
                            name="confirmPassword"
                            value={formData.confirmPassword}
                            onChange={handleChange}
                            className="form-control"
                            placeholder="Confirm new password"
                        />
                        {errors.confirmPassword && <div className="text-danger">{errors.confirmPassword}</div>}
                    </div>

                    {message && (
                        <div className={`alert ${message.includes('success') ? 'alert-success' : 'alert-danger'}`} role="alert">
                            {message}
                        </div>
                    )}

                    <div className="d-grid gap-2">
                        <button type="submit" className="btn btn-primary" disabled={loading}>
                            {loading ? 'Resetting Password...' : 'Reset Password'}
                        </button>
                    </div>
                </form>

                <div className="mt-3 text-center">
                    <a href="/login" className="text-decoration-none text-primary">
                        Back to Login
                    </a>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
